import React, { useState, useEffect } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import OptionChainWidget from '../IndexFnO/components/OptionChainWidget';
import DashboardCommonCard from '../../components/DashboardCommonCard';
import FutureContractRow from '../../components/FutureContractRow';
import ScrollIndicatorContainer from '../../components/ScrollIndicatorContainer';
import { ListRowSkeleton } from '../../components/DashboardSkeletons';
import { Skeleton, Paper, Grid } from '@mui/material';
import { formatSmartExpiry, findNearestFuture } from '../../utils/expiryUtils';
import { searchInstrument } from '../../../../services/backendAPI';



const STOCKS = [
  { name: 'RELIANCE',   token: 2885,  exchange: 'NSE', wsCode: 1 },
  { name: 'HDFCBANK',   token: 1333,  exchange: 'NSE', wsCode: 1 },
  { name: 'BHARTIARTL', token: 10604, exchange: 'NSE', wsCode: 1 },
  { name: 'SBIN',       token: 3045,  exchange: 'NSE', wsCode: 1 },
  { name: 'ICICIBANK',  token: 4963,  exchange: 'NSE', wsCode: 1 },
  { name: 'TCS',        token: 11536, exchange: 'NSE', wsCode: 1 },
  { name: 'BAJFINANCE', token: 317,   exchange: 'NSE', wsCode: 1 },
];

const StocksFnOTab = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeFuture, setActiveFuture] = useState(null);
  const [loadingFuture, setLoadingFuture] = useState(true);

  useEffect(() => {
    setLoadingFuture(true);
    const activeAsset = STOCKS[activeIndex];
    const searchQuery = activeAsset.name.replace(/\s+/g, '');
    
    searchInstrument(searchQuery).then(res => {
      const results = Array.isArray(res) ? res : (res?.result || res?.data || []);
      const nearest = findNearestFuture(results);
      if (nearest) {
        setActiveFuture(nearest);
      }
      setLoadingFuture(false);
    }).catch(err => {
      console.error(err);
      setLoadingFuture(false);
    });
  }, [activeIndex]);

  return (
    <Box sx={{ px: { xs: 1, lg: 3 }, pt: { xs: 0.5, lg: 1 }, pb: { xs: 1, lg: 3 }, maxWidth: '100%', margin: '0 auto' }}>
      {/* Stock Selector Cards Container */}
      <ScrollIndicatorContainer>
        {STOCKS.map((stock, index) => (
          <DashboardCommonCard 
            key={stock.name} 
            symbol={stock.name}
            token={stock.token}
            wsCode={stock.wsCode || 1}
            layout="fno"
            active={activeIndex === index}
            onClick={() => setActiveIndex(index)}
          />
        ))}
      </ScrollIndicatorContainer>

      {/* Main Content Area */}
      <Box sx={{ mt: 2 }}>
        {/* Future Contract Row */}
        {loadingFuture ? (
          <Box sx={{ mb: 2 }}>
             <Typography variant="subtitle2" fontWeight="700" mb={1}>Nearest {STOCKS[activeIndex].name} Futures</Typography>
             <Paper sx={{ p: 2, border: '1px solid #E0E0E0', borderRadius: 2, height: 68, display: 'flex', alignItems: 'center' }} elevation={0}>
               <Skeleton animation="wave" width="30%" height={24} />
             </Paper>
          </Box>
        ) : activeFuture ? (
          <FutureContractRow 
            title={`Nearest ${STOCKS[activeIndex].name} Futures`}
            symbol={activeFuture.trading_symbol}
            expiry={formatSmartExpiry(activeFuture.expiry)}
            token={activeFuture.token}
            wsCode={2} // NFO
            exchange={activeFuture.exchange}
            price_precision={activeFuture.price_precision}
            instrument={activeFuture}
          />
        ) : null}

        {/* Option Chain Strikes */}
        <Divider sx={{ my: 3, opacity: 0.5 }} />
        {loadingFuture ? (
          <Box sx={{ mt: 1 }}>
             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, gap: 1.5 }}>
               <Typography variant="subtitle2" fontWeight={800} color="text.primary">OPTIONS</Typography>
               <Skeleton animation="wave" variant="rounded" width={160} height={32} />
             </Box>
             <Grid container spacing={2} sx={{ mt: 1 }}>
               <Grid item xs={12} lg={6}>
                 <ListRowSkeleton count={5} rowHeight={56} />
               </Grid>
               <Grid item xs={12} lg={6}>
                 <ListRowSkeleton count={5} rowHeight={56} />
               </Grid>
             </Grid>
          </Box>
        ) : (
          <OptionChainWidget selectedIndex={STOCKS[activeIndex]} />
        )}
      </Box>
    </Box>
  );
};

export default StocksFnOTab;
